export default __webpack_public_path__ + "static/media/HASSAN_NL_SEQ16.b5c4308e.mp3";